import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import deepmerge from 'deepmerge';
import { Box, LinearProgress } from '@mui/material';

import useNotification from '../../../core/hooks/use_notification';
import { getDeliveryNotificationsNotificationData } from '../../../core/utils/notification_utils';
import { Button } from '../../common/button';
import { ROUTE_DELIVERY_NOTIFICATIONS_NEW } from '../../../core/constants';
import PaginationControls from '../../common/pagination_controls';
import { getDefaultPaginationQueryValues } from '../../../core/utils/api_utils';
import { getDeliveryNotificationsAction, getDeliveryNotificationsState } from '../../../features/communication/get_delivery_notifications';
import DeliveryNotificationsList from './delivery_notifications_list';
import { FormRouteEnum } from '../../../core/enums/common/route';
import PageHeader from '../../common/page_header';

const initialQueryParams = {
    ...getDefaultPaginationQueryValues,
    sort: ['workingName', 'asc']
};

const DeliveryNotificationsPage = () => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();
    const navigate = useNavigate();

    const getDeliveryNotifications = useSelector(getDeliveryNotificationsState);

    const [queryParams, setQueryParams] = useState(initialQueryParams);

    const refreshList = useCallback(() => {
        dispatch(getDeliveryNotificationsAction(queryParams))
            .then(response => showErrorMessage(getDeliveryNotificationsNotificationData(response)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, queryParams]);

    useEffect(() => {
        refreshList();
    }, [refreshList]);

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>

            <PageHeader
                title="Wzory powiadomień o dostawach"
                actions={
                    <Button
                        onClick={ () => navigate(ROUTE_DELIVERY_NOTIFICATIONS_NEW, { state: { action: FormRouteEnum.NEW } }) }>
                        Dodaj wzór
                    </Button>
                }
            />

            { getDeliveryNotifications?.loading && (
                <Box sx={ { width: '100%' } }>
                    <LinearProgress/>
                </Box>
            ) }

            { getDeliveryNotifications?.data?.content && (
                <Box sx={ { display: 'flex', flexDirection: 'column', gap: 2 } }>
                    <DeliveryNotificationsList refreshList={ refreshList }/>

                    <Box sx={ { display: 'flex', justifyContent: 'flex-end', mt: 1 } }>
                        <PaginationControls
                            currentPage={ getDeliveryNotifications?.data?.pageable?.pageNumber }
                            totalPages={ getDeliveryNotifications?.data?.totalPages }
                            setPage={ page => setQueryParams(prevState => deepmerge(prevState, { page })) }
                        />
                    </Box>
                </Box>
            ) }
        </Box>
    );
};

export default DeliveryNotificationsPage;